import { createRoot } from "react-dom/client"
import "./theme/theme.css"
import "./styles.css"
import "./globals.css"
import App from "./app/app"
import { StrictMode } from "react"
import { asyncWithLDProvider } from "launchdarkly-react-client-sdk"
import { launchdarklyConfig } from "./providers/launch-darkly"

async function main() {
  console.info("🚀 Starting app...")
  console.info("🚢 Release version:", import.meta.env.VITE_RELEASE_VERSION)
  const root = document.getElementById("root")
  const LDProvider = await asyncWithLDProvider(launchdarklyConfig)

  if (root) {
    createRoot(root).render(
      <StrictMode>
        <LDProvider>
          <App />
        </LDProvider>
      </StrictMode>,
    )
  }
}

main()
